import { render } from "./DomainBox.vue?vue&type=template&id=21a69a72&scoped=true&ts=true"
import script from "./DomainBox.vue?vue&type=script&lang=ts"
export * from "./DomainBox.vue?vue&type=script&lang=ts"

import "./box.css?vue&type=style&index=0&id=21a69a72&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a69a72"]])

export default __exports__